<template>
<div>    
<div class="main" >
    <div>
        <DiamondQuizTitle @closePage="emitclosePage"/>

        <div v-if="!showGemologistForm">
            <DiamondQuizDiamondMessage message="What is your priority when buying a diamond?" />


            <div class="diam_block mt-2">
                <div class="diam_wrap">
                    <div class="diam_box" :class="{ 'active-option': selectedOption === 'size', 'disabled': sizeBoxDisable }" @click="selectOption('size')">
                        <img src="~/assets/diamond_quiz/size.svg" alt="size-diamond" width="48" height="48">
                        <div class="name text-center">size</div>
                        <div class="tag text-center">Bigger Appearance</div>
                    </div>
                </div>
                <div class="diam_wrap">
                    <div class="diam_box" :class="{ 'active-option': selectedOption === 'balance', 'disabled': balanceBoxDisable }" @click="selectOption('balance')">
                        <img src="~/assets/diamond_quiz/balance.svg" alt="size-diamond" width="48" height="48">
                        <div class="rec_box">Recommended</div>
                        <div class="name text-center">Balance</div>
                        <div class="tag text-center">Balance of Size & Quality</div>
                    </div>
                </div>
                <div class="diam_wrap">
                    <div class="diam_box" :class="{ 'active-option': selectedOption === 'quality', 'disabled': qualityBoxDisable }" @click="selectOption('quality')">
                        <img src="~/assets/diamond_quiz/quality.svg" alt="size-diamond" width="48" height="48">
                        <div class="name text-center">QUALITY</div>
                        <div class="tag text-center">Best color + Clarity</div>
                    </div>
                </div>
            </div>
            <p class="error_msg" v-if="sizeBoxDisable && balanceBoxDisable && qualityBoxDisable">We have not found any diamond based on your search criteria, please change your selection to continue.</p>
            

        </div>
    </div>
    <!-- <div class="gemo" v-if="showGemologistForm">
        <GemologistForm :data="formData" />
    </div> -->
    <div>
        <div class="wrapper">
            <button :class="{'disabled': isDisabled || isLoading}" class="button text-center" @click="goToNextPage" :disabled="isDisabled" v-if="!showGemologistForm">
                <span v-if="isLoading">Please wait...</span>
                <span v-else>proceed</span>

            </button>
            <!-- <div class="help" :class="{'help_mod':showGemologistForm}">
                <p>Need Help? <br><span @click="toggleGemologistForm"> Consult our Gemologist </span> </p>
            </div> -->
        </div>
        <DiamondQuizFooter />
    </div>
</div>
    
</div>
</template>

<script setup>
import { diamondQuizStore } from '@/stores/diamond_quiz/diamond_quiz';

const store = diamondQuizStore()
const isDisabled = ref(false)

const selectedOption = ref('');

const sizeBoxDisable = ref(false);

const balanceBoxDisable = ref(false);

const qualityBoxDisable = ref(false);

const isLoading = ref(false);

const showGemologistForm = ref(false)

const toggleGemologistForm = () => {
    showGemologistForm.value = !showGemologistForm.value
}

const emit = defineEmits(['close'])

const selectOption = (name) => {
    selectedOption.value = name;
    store.setPrioritySort('',[],[]);
    store.setPriorityColorClarity([], [],'');
    store.setPriorityColorClaritySort([],[],'');

    if (name === 'size') {
    const colorString = ['H', 'G', 'F', 'E', 'D'].join(',');
    const clarityString = ['SI1', 'VS2', 'VS1','VVS2','VVS1','IF','FL'].join(',');
    store.setPrioritySort('CaratHigh',colorString,clarityString);
  } else if (name === 'quality') {
    const colorString = 'D';
    const clarityString = ['VVS1','IF'].join(',');
    store.setPriorityColorClarity(colorString, clarityString,'CaratHigh');
  } else if (name === 'balance') {
    const colorString = ['F', 'E', 'D'].join(',');
    const clarityString = ['VS1','VVS2','VVS1','IF'].join(',');
    store.setPriorityColorClaritySort(colorString, clarityString, 'CaratHigh');
  }
};

const emitclosePage = () => {
    emit('close')
}

const formData = reactive ({
    payload : store.getPayload,
    is_quiz: true
})

const checkSizeBox = async () => {
    try {

        const payload = store.getPayload

        const url = `/diamond/filter/loose?PriceFrom=${payload.PriceFrom}&PriceTo=${payload.PriceTo}&Sort=CaratHigh&Shape=${payload.Shape}&Color=H, G, F, E,D&Clarity=SI1, VS2, VS1,VVS2,VVS1,IF,FL`

        const res = await $fetch(useCountryPath(url))

        if(res.success) {
            if(res.data?.data?.length){
                sizeBoxDisable.value = false
            }else {
                sizeBoxDisable.value = true
                
            }
        }

    } catch (error) {
        console.log(error,'error')
    }
}


const checkBalanceBox = async () => {
    try {

        const payload = store.getPayload

        const url = `/diamond/filter/loose?PriceFrom=${payload.PriceFrom}&PriceTo=${payload.PriceTo}&Sort=CaratHigh&Shape=${payload.Shape}&Color=F, E, D&Clarity=VS1,VVS2,VVS1,IF`

        const res = await $fetch(useCountryPath(url))

        if(res.success) {
            if(res.data?.data?.length){
                balanceBoxDisable.value = false
            }else {
                balanceBoxDisable.value = true
                
            }
        }

    } catch (error) {
        console.log(error,'error')
    }
}


const checkQualityBox = async () => {
    try {

        const payload = store.getPayload

        const url = `/diamond/filter/loose?PriceFrom=${payload.PriceFrom}&PriceTo=${payload.PriceTo}&Sort=CaratHigh&Shape=${payload.Shape}&Color=D&Clarity=VVS1,IF`

        const res = await $fetch(useCountryPath(url))

        if(res.success) {
            if(res.data?.data?.length){
                qualityBoxDisable.value = false
            }else {
                qualityBoxDisable.value = true
                
            }
        }

    } catch (error) {
        console.log(error,'error')
    }
}




const goToNextPage = async () => {
    try {
        isLoading.value = true
        
        const payload = store.getPayload
        
        const res = await $fetch(useCountryPath('/diamond/filter/loose'),{
            query:payload
        })


        if(res.success){
            if(res.data?.data?.length){
                isDisabled.value = false
                store.setResult(res.data.data);
                store.setNextPage()
            }else{
                isDisabled.value = true
                selectedOption.value = ''
            }
            
        }
        
    } catch (error) {
        console.log(error,'error')
    }finally{
        isLoading.value = false
    }

}



onMounted(() => {
    checkSizeBox();
    checkBalanceBox();
    checkQualityBox();

    const storedSort = store.getPrioritySize;
    const storedColor = store.getPriorityColor;
    const storedClarity = store.getPriorityClarity;

    
    if (
        storedSort === 'CaratHigh' &&
        storedColor === 'H,G,F,E,D' &&
        storedClarity === 'SI1,VS2,VS1,VVS2,VVS1,IF,FL'
    ) {
        selectedOption.value = 'size';
    } else if (
        storedSort === 'CaratHigh' &&
        storedColor === 'D' &&
        storedClarity === 'VVS1,IF'
    ) {
        selectedOption.value = 'quality';
    } else if (
        storedSort === 'CaratHigh' &&
        storedColor === 'F,E,D' &&
        storedClarity === 'VS1,VVS2,VVS1,IF'
    ) {
        selectedOption.value = 'balance';
    } else {
        selectedOption.value = ''; // No option previously selected
    }
});



</script>


<style scoped>
p.error_msg {
    text-align: center;
    color: #ff0000;
    margin-top: 20px;
}
.gemo {
    max-width: 400px;
    margin: 0 auto;
}

.main {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 90vh;
    overflow: auto;
    overflow-x: hidden;
}
br{
    display: none;
}
.back {
    position: absolute;
    top: 12px;
    left: 12px;
    cursor: pointer;
}
.largeBack {
    transform: scale(1.5);
    cursor: pointer;
}

.content {
    display: flex;
    justify-content: center;
    align-items: center;
}

.diam_block {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 16px;
    margin: 0 7%;
}

.diam_wrap {
    width: 27%;
}

.dialog_box {
    font-size: 18px;
    font-style: italic;
    color: #405955;
    border: 1px solid var(--green);
    border-radius: 4px;
    padding: 10px;
}

.diam_box {
    padding: 32px 12px;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 8px;
    cursor: pointer;
    position: relative;
    border: 1px solid transparent;
    box-shadow: 0 0 8px 0 rgba(102, 139, 132, 0.4);
}

.diam_box.active-option {
    background-color: #668b8419;
    border: 1px solid var(--green);
}

.rec_box {
    position: absolute;
    text-transform: Capitalize;
    top: 0px;
    left: 0px;
    font-size: 12px;
    background:var(--green);
    color:  #eaeaea;
    border-radius: 4px 0 0 0;
    padding: 4px 16px 4px 8px;
    min-width: auto;
    /* text-align: center; */
    clip-path: polygon(0% -1%, 100% -1%, 85% 100%, 0% 100%);
    /* font-weight: 600; */
}

.diam_box img {
    margin-bottom: 12px;
}

.name {
    font-size: 14px;
    font-weight: 600;
    color: #405955;
    text-transform: uppercase;
    letter-spacing: 2px;
    margin-bottom: 12px;
}

.tag {
    font-size: 12px;
    color: #909090;
    font-style: italic;
}

.button {
    padding: 14px 30px;
    border: 1.5px solid var(--green);
    border-radius: 4px;
    width: 40%;
    margin: 0 auto;
    background: var(--green);
    cursor: pointer;
    margin-bottom: 12px;
}

.button span {
    font-size: 14px;
    font-weight: 700;
    color: #fff;
    text-transform: uppercase;
    letter-spacing: 1.4px;
}

.help {
    font-size: 14px;
    text-align: center;
}

.help p {
    color: #353535;
}

.help span {
    color: var(--green);
    text-decoration: underline;
    cursor: pointer;
}

.wrapper {
    display: flex;
    flex-direction: column;
}

.disabled{
    pointer-events: none;   
    opacity: 0.7;
}

.diam_box.disabled{
    border: none;
    background-color: #fff;
}

@media(max-width:992px){
    .content img {
        width: 100px;
        height: 100px;
    }
    .dialog_box {
        font-size: 16px;
    }

    .button {
        width: 60%;
        padding: 10px 15px;
    }

}

@media(max-width:768px) {
    br{
        display: block;
    }
    .content img {
        width: 80px;
        height: 80px;
    }

    .dialog_box {
        font-size: 14px;
    }

    .button {
        width: 96%;
        margin: 0;
        
    }
    .wrapper{
        flex-direction: row-reverse;
        /* justify-content: space-between; */
        justify-content: center;
        align-items: center;
        /* padding: 0 10px; */
        /* width: 100%; */
    }

    .name {
        margin-bottom: 4px;
    }

    .help {
        text-align: left;
        margin-top: 5px;
        width: 50%;
        
    }

    .diam_box {
        padding: 8px;
        min-height: 150px;
    }

    .rec_box {
        display: none;
    }

    .diam_block {
        margin: 24px 0;
    }

    .main {
        height: auto;
    }

    .diam_wrap {
        width: 29%;
    }

    .help_mod {
        width: 100%;
    }

    .help_mod br {
        display: none;
    }

    .help_mod p {
        text-align: center;
    }

}

@media(max-width:500px) {
    .gemo {
        padding: 10px;
    }
}



</style>